import { ServiceStatus } from "@/models/enums/service";
import { mergeObjects } from "@/utils/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Service from "@/services";
import { CheckinPublishCustomer, getListPublish } from "@/services/api/publish";
const service = new Service.PublishService();

export interface LeagueState {
  customer: {
    network: {
      code: ServiceStatus;
      error?: string;
    };
    data?: any;
  };
}

const initialState: LeagueState = {
  customer: {
    network: {
      code: ServiceStatus.idle,
      error: undefined,
    },
    data: undefined,
  },
};
/**
 * @link https://redux-toolkit.js.org/api/createSlice
 */
export const slice = createSlice({
  name: "league",
  initialState,
  //basic state change
  reducers: {
    reset: () => initialState,
    patch: (state, action) => mergeObjects({ ...state }, action.payload),
  },
  //async trunk state change
  extraReducers(builder) {
    builder.addCase(fetchPublishCustomer.pending, (state, action) => {
      state.customer.network.code = ServiceStatus.loading;
    });
    builder.addCase(fetchPublishCustomer.rejected, (state, action) => {
      state.customer.network.error = action.error.message;
      state.customer.network.code = ServiceStatus.failed;
    });
    builder.addCase(fetchPublishCustomer.fulfilled, (state, action) => {
      state.customer.network.code = ServiceStatus.succeeded;
      state.customer.data = action.payload;
    });
  },
});

export const fetchPublishCustomer = createAsyncThunk("publish/fetch", async (param: getListPublish, thunkAPI) => {
  const resp = await service.getListPublish(param).catch((err: any) => {
    return thunkAPI.rejectWithValue(err.message);
  });
  return resp;
});

export const addPublish = createAsyncThunk("publish/add", async (param: CheckinPublishCustomer, thunkAPI) => {
  const resp = await service.checkInPublishCustomer(param).catch((err: any) => {
    console.error("quest error", err);
    return thunkAPI.rejectWithValue(err.message);
  });
  return resp;
});

export const { reset, patch } = slice.actions;

export default slice.reducer;
